import {
  localization,
  SurveyQuestionEditorDefinition,
} from 'survey-creator-react';
import { ElementFactory, Question, Serializer } from 'survey-core';
import {
  SurveyQuestionElementBase,
  ReactQuestionFactory,
} from 'survey-react-ui';

import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { sentiments, OptionType } from './sentimentColors';

const Selected = styled.p`
  cursor: pointer;
  padding: 0;
  margin: 0.5rem;
`;

const Container = styled.div`
  position: relative;
  border: 1px solid #ccc;
  background-color: white;
`;

const Ul = styled.ul`
  position: absolute;
  top: 1rem;
  left: 0;
  padding: 0;
  list-style-type: none;
  background: white;
  z-index: 1;
  border: 1px solid #ccc;
`;

const Li = styled.li`
  padding: 4px 8px;

  &:hover {
    background-color: #2eb394;
    color: white;
  }
`;
const Mask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const SentimentBox = styled.div<{ color: string }>`
  border-left: 1px solid #ccc;
  width: 1rem;
  height: 2rem;
  margin-left: auto;
  background-color: ${({ color }) => color};
`;

export const Select = ({ saveValue, value }: any) => {
  const [selectedValue, setValue] = useState<OptionType>({
    value: value || null,
    text: value
      ? sentiments.find(
          (option: OptionType) => option.value === value.toString()
        )?.text
      : 'none',
    color: value
      ? sentiments.find(
          (option: OptionType) => option.value === value.toString()
        )?.color
      : 'transparent',
  });

  const [isOpen, setOpen] = useState(false);

  return (
    <Container
      id="select"
      onClick={(e: any) => {
        if (e.currentTarget.id === 'select') {
          setOpen(!isOpen);
        }
      }}
    >
      {isOpen && <Mask onClick={() => setOpen(false)} />}
      <Wrapper>
        <Selected>{selectedValue.text}</Selected>
        <SentimentBox color={selectedValue.color || 'transparent'} />
      </Wrapper>
      {isOpen && (
        <Ul>
          {sentiments.map((option: OptionType) => (
            <Li
              key={option.value || option.text}
              onClick={() => {
                setValue(option);
                saveValue(option.value);
              }}
            >
              {option.text}
            </Li>
          ))}
        </Ul>
      )}
    </Container>
  );
};

// create model for new question type
export class QuestionSentimentModel extends Question {
  getType() {
    return 'sentiment';
  }
  get sentimentType() {
    return this.getPropertyValue('sentimentType');
  }
  set sentimentType(val) {
    this.setPropertyValue('sentimentType', val);
  }
}

// set display title for question type
localization.getLocale('').qt.sentiment = 'Sentiment';

// this serializes the class into JSON
Serializer.addClass(
  'sentiment',
  [
    {
      name: 'sentimentType',
    },
  ],
  function () {
    return new QuestionSentimentModel('');
  },
  'question'
);

SurveyQuestionEditorDefinition.definition.sentiment = {
  properties: [{ name: 'sentimentType', tab: 'layout' }],
};

// register question with its model
export function registerSentiment() {
  ElementFactory.Instance.registerElement('sentiment', (name: string) => {
    return new QuestionSentimentModel(name);
  });
}

export class SurveyQuestionSentiment extends SurveyQuestionElementBase {
  constructor(props: any) {
    super(props);
    this.state = { value: this.question.value };
  }
  get question() {
    return this.questionBase;
  }
  get value() {
    return this.question.value;
  }

  get type() {
    // @ts-ignore
    return this.question.sentimentType;
  }
  handleSentimentChange = (data: any) => {
    this.question.value = data;
    this.setState({ value: data });
  };

  // support readOnly and designMode
  get style() {
    return this.question.getPropertyValue('readOnly') ||
      this.question.isDesignMode
      ? {
          pointerEvents: 'none',
        }
      : undefined;
  }

  renderElement() {
    return (
      <Select saveValue={this.handleSentimentChange} value={this.state.value} />
    );
  }
}

ReactQuestionFactory.Instance.registerQuestion('sentiment', (props: any) => {
  return React.createElement(SurveyQuestionSentiment, props);
});
